import { useMemo, useRef } from 'react';
export function useTooltipShadowPlugin() {
    const tooltipEl = useRef(null);
    const plugin = useMemo(() => ({
        id: 'tooltipShadow',
        beforeInit: (chart) => {
            // Create custom tooltip container
            const { canvas } = chart;
            tooltipEl.current = document.createElement('div');
            tooltipEl.current.style.position = 'absolute';
            tooltipEl.current.style.pointerEvents = 'none';
            tooltipEl.current.style.zIndex = '1000';
            tooltipEl.current.style.boxShadow = '0px 8px 24px 0px #0000000A, 0px 0px 3px 0px #00000014';
            tooltipEl.current.style.borderRadius = '8px';
            tooltipEl.current.style.backgroundColor = 'transparent';
            tooltipEl.current.style.display = 'none';
            canvas.parentNode?.appendChild(tooltipEl.current);
        },
        afterDraw: (chart) => {
            const { tooltip } = chart;
            if (tooltip && tooltip.opacity > 0 && tooltipEl.current) {
                // Position the custom tooltip shadow to match the actual tooltip position
                tooltipEl.current.style.display = 'block';
                tooltipEl.current.style.left = `${tooltip.x}px`;
                tooltipEl.current.style.top = `${tooltip.y}px`;
                tooltipEl.current.style.width = `${tooltip.width}px`;
                tooltipEl.current.style.height = `${tooltip.height}px`;
            }
            else if (tooltipEl.current) {
                tooltipEl.current.style.display = 'none';
            }
        },
        afterDestroy: () => {
            if (tooltipEl.current) {
                tooltipEl.current.remove();
                tooltipEl.current = null;
            }
        },
    }), []);
    return plugin;
}
